function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTileWxTornado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.69 128.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.69,
    height: 128.69,
    rx: 17.64,
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08,37.29h-7.4a3.15,3.15,0,0,1,0-6.3h7.4a3.15,3.15,0,1,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9,37.29H23.31a3.15,3.15,0,0,1,0-6.3H68.9a3.15,3.15,0,0,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.43,27H28.1a3.15,3.15,0,0,1,0-6.3H99.43a3.15,3.15,0,0,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,47.64H68.61a3.15,3.15,0,0,1,0-6.3H83a3.15,3.15,0,1,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.53,47.64H30a3.15,3.15,0,1,1,0-6.3H57.53a3.15,3.15,0,1,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.15,58h-34a3.15,3.15,0,0,1,0-6.3h34a3.15,3.15,0,0,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.85,58H38.74a3.15,3.15,0,0,1,0-6.3h6.11a3.15,3.15,0,0,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.13,68.32H52.44a3.15,3.15,0,0,1,0-6.3H99.13a3.15,3.15,0,0,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.87,78.66H99.14a3.15,3.15,0,0,1,0-6.3h4.73a3.15,3.15,0,0,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.36,78.66H65.81a3.15,3.15,0,0,1,0-6.3H89.36a3.15,3.15,0,1,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,89h-10a3.15,3.15,0,0,1,0-6.3h10a3.15,3.15,0,0,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.17,89H74.59a3.15,3.15,0,0,1,0-6.3h5.58a3.15,3.15,0,0,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.81,99.35H69a3.15,3.15,0,0,1,0-6.3H85.81a3.15,3.15,0,0,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.35,109.69H61.66a3.15,3.15,0,0,1,0-6.3h8.69a3.15,3.15,0,0,1,0,6.3Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileWxTornado);
export default __webpack_public_path__ + "static/media/tile_WXTornado.f8eb8de1b42d798d1ee28d7c3b80ae61.svg";
export { ForwardRef as ReactComponent };